const STORAGE_PREFIX = 'kb-recent-links:';
const MAX_RECENT_LINKS = 10;

export const TASK_SOCIAL_LINK_RECENT_KEY = 'task-social-link';
export const PROMOTER_TG_LINK_RECENT_KEY = 'promoter-tg-link';

const ALLOWED_TASK_HOST_PATTERNS = [
    /(^|\.)youtube\.com$/i,
    /^youtu\.be$/i,
    /(^|\.)x\.com$/i,
    /(^|\.)twitter\.com$/i,
    /^t\.co$/i,
    /^t\.me$/i,
    /(^|\.)telegram\.(me|org)$/i,
    /(^|\.)discord\.(com|gg)$/i,
    /(^|\.)discordapp\.com$/i,
    /(^|\.)tiktok\.com$/i,
    /(^|\.)instagram\.com$/i,
    /(^|\.)reddit\.com$/i,
    /^redd\.it$/i,
    /(^|\.)vk\.(com|ru)$/i,
    /(^|\.)threads\.(net|com)$/i,
    /(^|\.)linkedin\.com$/i,
    /(^|\.)twitch\.tv$/i,
    /(^|\.)dexscreener\.com$/i,
    /(^|\.)dextools\.io$/i,
    /(^|\.)pinterest\.com$/i,
    /^pin\.it$/i,
];

function normalizeLink(link) {
    const trimmed = String(link || '').trim();
    if (!trimmed) return '';
    return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

export function isAllowedTaskSocialLink(link) {
    const normalized = normalizeLink(link);
    if (!normalized) return false;
    try {
        const parsed = new URL(normalized);
        if (!['http:', 'https:'].includes(parsed.protocol)) return false;
        const host = parsed.hostname.toLowerCase();
        return ALLOWED_TASK_HOST_PATTERNS.some((pattern) => pattern.test(host));
    } catch {
        return false;
    }
}

function canStoreLink(key, link) {
    if (key === TASK_SOCIAL_LINK_RECENT_KEY) {
        return isAllowedTaskSocialLink(link);
    }
    return Boolean(String(link || '').trim());
}

function persistRecentLinks(key, links) {
    try {
        localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(links));
    } catch {
        // ignore quota / private mode errors
    }
}

export function getRecentLinks(key) {
    if (!key) return [];
    try {
        const raw = localStorage.getItem(`${STORAGE_PREFIX}${key}`);
        const parsed = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(parsed)) return [];

        const filtered = parsed
            .map((item) => String(item || '').trim())
            .filter((item) => canStoreLink(key, item));

        if (filtered.length !== parsed.length) {
            persistRecentLinks(key, filtered);
        }

        return filtered;
    } catch {
        return [];
    }
}

export function addRecentLink(key, link) {
    if (!key) return;
    const trimmed = (link || '').trim();
    if (!trimmed) return;
    if (!canStoreLink(key, trimmed)) return;

    const next = [trimmed, ...getRecentLinks(key).filter((item) => item !== trimmed)].slice(0, MAX_RECENT_LINKS);
    persistRecentLinks(key, next);
}
